module.exports = "<ag-grid-angular class=\"table-container\"\n  [gridOptions]=\"options\"\n  [toolPanelSuppressSideButtons]=\"true\"\n  (cellClicked)=\"onCellClicked($event)\"\n  [suppressCellSelection] = \"true\"\n  enableSorting\n  [overlayLoadingTemplate]=\"overlayLoadingTemplate\"\n>\n</ag-grid-angular>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/property/components/tables/property-table.component.html
// module id = ./src/app/features/property/components/tables/property-table.component.html
// module chunks = main